module.exports = __webpack_public_path__ + "img/adam-login-logo-manager.9f4fae6d.png";